const numberFormatMap: SliderNumberFormatMap = {
    USD: {
        // use thousands separators, two decimal places and dollar sign for value label
        // example: 10000 => '$10,000.00'
        value: { style: 'currency', currency: 'USD' },
        // use compact style for min/max labels
        // example: 10000 => '$10k'
        minMax: {
            compactDisplay: 'short',
            currency: 'USD',
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            notation: 'compact',
            style: 'currency',
        },
    },
    none: {
        // For both value label and min/max labels, use thousands separator only
        // example: 10000 => '10,000'
        value: undefined,
        minMax: undefined,
    },
    percent: {
        value: {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
        minMax: {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        },
    },
};

/**
 * Given a SliderNumberFormat, return its corresponding value from the numberFormatMap above.
 * @param sliderNumberFormat - see {@link SliderNumberFormat}
 * @returns a {@link SliderNumberFormatConfig} object
 */
export const getSliderNumberFormatConfig = (
    sliderNumberFormat: SliderNumberFormat,
): SliderNumberFormatConfig => numberFormatMap[sliderNumberFormat];
